import React, { useState } from 'react';
import styles from '../assets/styles/PasswordReset.module.scss';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (res.ok) {
        setIsSent(true);
      } else {
        alert('送信に失敗しました。メールアドレスが正しいかご確認ください。');
      }
    } catch (error) {
      alert('サーバーとの通信に失敗しました。');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.containerWrap}>
      <div className={styles.backgroundGlow}>
        <div className={styles.glowBlue} />
        <div className={styles.glowPink} />
      </div>
      <a href="/login" className={styles.backLink}>← ログインへ戻る</a>

      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <div className={styles.formArea}>
              <img src="/images/logo_aibex_line_b.svg" alt="AI-BEX" className={styles.logo} />

              <h1>パスワードをお忘れの方</h1>
              {isSent ? (
                <p className={styles.description}>
                  再設定用のメールを送信しました。<br />
                  メール内のリンクをクリックして手続きを完了してください。
                </p>
              ) : (
                <>
                  <p className={styles.description}>
                    パスワード再設定フォームをお送りいたします。<br />
                    ご登録メールアドレスを入力して送信してください。
                  </p>
                  <form onSubmit={handleSubmit}>
                    <label>メールアドレス</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="email@example.com"
                      required
                      className={styles.inputTxt}
                    />
                    <button type="submit" disabled={isLoading}>
                      {isLoading ? '送信中...' : '送信する'}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
